"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVoicesAsObject = exports.getTextToSpeechStats = exports.getSectionCount = exports.getSaveNeeded = exports.getRedoElements = exports.getNewElements = exports.getListForPreview = exports.getLanguageVoices = exports.getIsEmpty = exports.getFakeDynamicUserListsValues = exports.getElementsWithDataConnectors = exports.getElementsInOrder = exports.getElementVoices = exports.getElementTreeForSaving = exports.getElementTree = exports.getDirtyElements = exports.getDeletedElements = exports.getDataConnectorsTree = exports.getCurrentPlayerTemplate = exports.getCurrentElementVoice = exports.getCurrentElementId = exports.getCurrentElement = exports.getConnectedIdsForCurrentComponent = exports.getAllQuestionStartNumbers = exports.getAllElementsAsObject = exports.getAllDataConnectors = void 0;
var _reselect = require("reselect");
var _keys2 = _interopRequireDefault(require("lodash/keys"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _forEach2 = _interopRequireDefault(require("lodash/forEach"));
var _difference2 = _interopRequireDefault(require("lodash/difference"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _mapValues2 = _interopRequireDefault(require("lodash/mapValues"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _flattenDeep2 = _interopRequireDefault(require("lodash/flattenDeep"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _isObject2 = _interopRequireDefault(require("lodash/isObject"));
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
var _isPlainObject2 = _interopRequireDefault(require("lodash/isPlainObject"));
var _common = require("./common.js");
var _getWysiwygText = _interopRequireDefault(require("cccisd-survey-common/dist/helpers/getWysiwygText.js"));
var _stripTags = _interopRequireDefault(require("cccisd-survey-common/dist/helpers/stripTags.js"));
var _allTemplates = require("../allTemplates.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var playerTemplateList = (0, _allTemplates.getTemplateList)('players', 'flow');
var getCurrentElementIdFromState = function getCurrentElementIdFromState(state) {
  return state.currentElementId;
};
var getRootId = function getRootId(state) {
  return state.rootId;
};
var getElements = function getElements(state) {
  return state.elements;
};
var getSavedElements = function getSavedElements(state) {
  return state.savedElements;
};
var getSettings = function getSettings(state) {
  return state.settings;
};
var getDraggedElementId = function getDraggedElementId(state) {
  return state.draggedElementId;
};
var getAllElements = function getAllElements(state) {
  return state.allElements;
};
var getDynamicDataConnectors = function getDynamicDataConnectors(state) {
  return state.dynamicDataConnectors;
};
var getDynamicUserLists = function getDynamicUserLists(state) {
  return state.dynamicUserLists;
};
var getLanguage = function getLanguage(state) {
  return state.language;
};
var getVoices = function getVoices(state) {
  return state.voices;
};
var getVoicesAsObject = exports.getVoicesAsObject = (0, _reselect.createSelector)(getVoices, function (voices) {
  return voices.reduce(function (obj, voice) {
    obj[voice.value] = voice;
    return obj;
  }, {});
});
var getLanguageVoices = exports.getLanguageVoices = (0, _reselect.createSelector)(getLanguage, getVoices, function (language, voices) {
  return voices.filter(function (item) {
    return item.language === language;
  });
});
var getCurrentElementId = exports.getCurrentElementId = (0, _reselect.createSelector)(getCurrentElementIdFromState, getElements, function (id, elements) {
  return elements[id] ? id : 0;
});
var getCurrentElement = exports.getCurrentElement = (0, _reselect.createSelector)(getCurrentElementId, getElements, getRootId, function (id, elements, rootId) {
  if (!elements[id]) {
    return {};
  }
  var rootChildren = elements[rootId].children;
  return _objectSpread(_objectSpread({}, elements[id]), {}, {
    isTopLevel: rootChildren.includes(id)
  });
});
var getSaveNeeded = exports.getSaveNeeded = (0, _reselect.createSelector)(getElements, getSavedElements, function (elements, savedElements) {
  {
    var str1 = (0, _map2["default"])(elements, 'settingsHash').join('');
    var str2 = (0, _map2["default"])(savedElements, 'settingsHash').join('');
    if (str1 !== str2) {
      return true;
    }
  }
  {
    var _str = (0, _flattenDeep2["default"])((0, _map2["default"])(elements, 'children')).join('_');
    var _str2 = (0, _flattenDeep2["default"])((0, _map2["default"])(savedElements, 'children')).join('_');
    if (_str !== _str2) {
      return true;
    }
  }
  return false;
});
var getDirtyElements = exports.getDirtyElements = (0, _reselect.createSelector)(getElements, getSavedElements, function (elements, savedElements) {
  var result = [];
  (0, _forEach2["default"])(elements, function (element, key) {
    var savedElement = savedElements[key];
    if (savedElement && savedElement.settingsHash !== element.settingsHash) {
      result.push(key);
    }
  });
  return result.map(function (item) {
    return +item;
  });
});
var getRedoElements = exports.getRedoElements = (0, _reselect.createSelector)(getElements, function (elements) {
  var result = [];
  (0, _forEach2["default"])(elements, function (element, key) {
    if (element.redoSettings) {
      result.push(+key);
    }
  });
  return result;
});
var getNewElements = exports.getNewElements = (0, _reselect.createSelector)(getElements, getSavedElements, function (elements, savedElements) {
  var ids = (0, _keys2["default"])(elements);
  var savedIds = (0, _keys2["default"])(savedElements);
  return (0, _difference2["default"])(ids, savedIds).map(function (item) {
    return +item;
  });
});
var getDeletedElements = exports.getDeletedElements = (0, _reselect.createSelector)(getElements, getSavedElements, function (elements, savedElements) {
  var ids = (0, _keys2["default"])(elements);
  var savedIds = (0, _keys2["default"])(savedElements);
  return (0, _difference2["default"])(savedIds, ids).map(function (item) {
    return +item;
  });
});
var getElementTree = exports.getElementTree = (0, _reselect.createSelector)(getElements, getRootId, getDraggedElementId, function (elements, rootId, draggedElementId) {
  function getChildren(elementId) {
    var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var element = elements[elementId];
    if (!element) {
      return {};
    }
    var result = (0, _omit2["default"])(element, 'children');
    result.parents = parents;
    result.level = level;
    if (element.children && element.children.length > 0) {
      if (elementId === draggedElementId) {
        result.children = [];
      } else {
        result.children = element.children.map(function (id) {
          return getChildren(id, [elementId].concat(_toConsumableArray(parents)), level + 1);
        });
        result.children[result.children.length - 1].isLastChild = true;
      }
    }
    return result;
  }
  return getChildren(rootId);
});
var getElementTreeForSaving = exports.getElementTreeForSaving = (0, _reselect.createSelector)(getElements, getRootId, function (elements, rootId) {
  function replaceResources(node) {
    if (Array.isArray(node)) {
      return node.map(function (item) {
        return replaceResources(item);
      });
    }
    if (node === null || _typeof(node) !== 'object') {
      return node;
    }
    if (node.meta && (node.meta.audio || node.meta.images)) {
      if (node.meta.audio) {
        node.meta.audio = "resources.file.meta(".concat(node.meta.audio.resourceId, ")");
      }
      if (node.meta.images) {
        node.content = node.content.replace(/<img[^>]* data-image="([\d]+)"[^>]*>/g, function (value, resourceId) {
          value = value.replace(/ (src|data-image)="[^"]*"/g, '').replace(/^(<img)/, "$1 file=\"resources.file.img(".concat(resourceId, ")\""));
          return value;
        });
        node.meta.images = (0, _mapValues2["default"])(node.meta.images, function (value, key) {
          return "resources.file.meta(".concat(key, ")");
        });
      }
      return node;
    }
    return (0, _mapValues2["default"])(node, function (value) {
      return replaceResources(value);
    });
  }
  function getChildren(id) {
    return elements[id].children.map(function (childId) {
      var item = elements[childId];
      var result = {
        type: item.type,
        content: [{
          content: JSON.stringify(replaceResources((0, _cloneDeep2["default"])(item.settings))),
          lang: 'en-us'
        }]
      };
      if (item.isNew) {
        result.status = 'new';
        result.tmpId = item.id;
      } else {
        result.status = 'updated';
        result.id = item.id;
      }
      if (item.settingsId) {
        result.content[0].id = item.settingsId;
      }
      if (item.children && item.children.length > 0) {
        result.children = getChildren(item.id);
      }
      return result;
    });
  }
  return {
    id: rootId,
    children: getChildren(rootId)
  };
});
var getListForPreview = exports.getListForPreview = (0, _reselect.createSelector)(getElements, getRootId, function (elements, rootId) {
  var result = (0, _mapValues2["default"])(elements, function (item) {
    return (0, _pick2["default"])(item, ['id', 'type', 'settings', 'children', 'skipPlaying', 'returnControlAfterChildren', 'isAloneOnThePage']);
  });
  result[0] = _objectSpread(_objectSpread({}, result[rootId]), {}, {
    id: 0
  });
  delete result[rootId];
  return result;
});
var getSectionCount = exports.getSectionCount = (0, _reselect.createSelector)(getElements, getRootId, function (elements, rootId) {
  if (!elements[rootId]) {
    return 0;
  }
  return elements[rootId].children.length;
});
var getElementsInOrder = exports.getElementsInOrder = (0, _reselect.createSelector)(getElements, getRootId, function (elements, rootId) {
  var result = [];
  function getElementWithChildren(id) {
    var item = elements[id];
    result.push(item);
    if (item.children && item.children.length > 0) {
      item.children.forEach(function (childId) {
        return getElementWithChildren(childId);
      });
    }
  }
  getElementWithChildren(rootId);
  return result;
});
var getElementsWithDataConnectors = exports.getElementsWithDataConnectors = (0, _reselect.createSelector)(getAllElements, function (allElements) {
  return (0, _filter2["default"])(allElements, function (element) {
    return element.getDataConnectors;
  }).map(function (element) {
    return element.code;
  });
});

/**
 * Get all component Ids which have dataConnector to the current component (directly or indirectly)
 */
var getConnectedIdsForCurrentComponent = exports.getConnectedIdsForCurrentComponent = (0, _reselect.createSelector)(getElements, getCurrentElementId, function (elements, currentElementId) {
  var connectors = {};
  var getConnectors = function getConnectors(id, obj) {
    if (!(0, _isPlainObject2["default"])(obj) && !(0, _isArray2["default"])(obj)) {
      return;
    }
    if ((0, _isPlainObject2["default"])(obj) && obj.instance === 'dataConnector') {
      if (obj.category === 'flow') {
        connectors[obj.id] = [].concat(_toConsumableArray(connectors[obj.id] || []), [id]);
      }
      return;
    }
    (0, _forEach2["default"])(obj, function (child) {
      return getConnectors(id, child);
    });
  };
  (0, _forEach2["default"])(elements, function (element) {
    return getConnectors(element.id, element);
  });
  var result = [];
  var processItem = function processItem(id) {
    if (!connectors[id]) {
      return;
    }
    connectors[id].forEach(function (child) {
      result.push(child);
      processItem(child);
    });
  };
  processItem(currentElementId);
  return result;
});
var getDataConnectorsTree = exports.getDataConnectorsTree = (0, _reselect.createSelector)(getElements, getCurrentElementId, getRootId, getAllElements, getElementsWithDataConnectors, getConnectedIdsForCurrentComponent, getDynamicDataConnectors, function (elements, currentElementId, rootId, allElements, elementsWithDataConnectors, connectedIds, dynamicDataConnectors) {
  if (!elements[rootId] || !elements[rootId].children) {
    return [];
  }
  var getDataConnectors = function getDataConnectors(element) {
    var elementType = (0, _find2["default"])(allElements, {
      code: element.type
    });
    return (0, _map2["default"])(elementType.getDataConnectors(element.settings), function (item, key) {
      return {
        id: "flow_".concat(element.id, "_").concat(key),
        value: {
          category: 'flow',
          id: element.id,
          type: item.type,
          name: key,
          title: "".concat(elementType.name, " (").concat(item.title, ")")
        },
        type: item.type,
        title: item.title,
        deprecated: !!item.deprecated
      };
    });
  };
  var getChildren = function getChildren(element) {
    var children = [];
    element.children.forEach(function (childId) {
      var child = elements[childId];
      var elementType = (0, _find2["default"])(allElements, {
        code: child.type
      });
      var item = {
        id: "flow_".concat(child.id),
        title: (0, _getWysiwygText["default"])(child.settings[elementType.labelField]),
        icon: elementType.icon
      };
      if (currentElementId === child.id) {
        children.push(_objectSpread(_objectSpread({}, item), {}, {
          disabled: true,
          disabledReason: 'self'
        }));
        return;
      }
      if (connectedIds.includes(child.id)) {
        children.push(_objectSpread(_objectSpread({}, item), {}, {
          disabled: true,
          disabledReason: 'circular'
        }));
        return;
      }
      if (!child.children && !elementsWithDataConnectors.includes(child.type)) {
        children.push(_objectSpread(_objectSpread({}, item), {}, {
          disabled: true,
          disabledReason: 'noData'
        }));
        return;
      }
      children.push(_objectSpread(_objectSpread({}, item), {}, {
        isAdult: true,
        children: child.children ? getChildren(child) : getDataConnectors(child)
      }));
    });
    return children;
  };
  var getDynamicChildren = function getDynamicChildren(element) {
    return element.map(function (child) {
      if (child.children) {
        return {
          id: "dynamic_".concat(child.handle),
          title: child.label,
          isAdult: true,
          children: getDynamicChildren(child.children)
        };
      }
      return {
        id: "dynamic_".concat(child.handle),
        title: child.label,
        type: child.type,
        value: {
          category: 'dynamic',
          type: child.type,
          name: child.handle,
          title: child.label
        }
      };
    });
  };
  var result = [];
  result.push({
    id: 'components',
    title: 'Components',
    isAdult: true,
    children: getChildren(elements[rootId])
  });
  if (dynamicDataConnectors && dynamicDataConnectors.length > 0) {
    result.push({
      id: 'dynamic',
      title: 'App variables',
      isAdult: true,
      children: getDynamicChildren(dynamicDataConnectors)
    });
  }
  return result;
});
var getAllDataConnectors = exports.getAllDataConnectors = (0, _reselect.createSelector)(getElements, function (elements) {
  var result = [];
  var processItem = function processItem(item) {
    if (!(0, _isObject2["default"])(item) && !(0, _isArray2["default"])(item)) {
      return;
    }
    if ((0, _isObject2["default"])(item) && item.instance === 'dataConnector') {
      result.push(item);
      return;
    }
    (0, _forEach2["default"])(item, function (child) {
      return processItem(child);
    });
  };
  processItem(elements);
  return result;
});
var getAllQuestionStartNumbers = exports.getAllQuestionStartNumbers = (0, _reselect.createSelector)(getElements, getAllElements, getRootId, function (list, allElements, rootId) {
  var adjustedList = _objectSpread(_objectSpread({}, list), {}, {
    0: list[rootId]
  });
  return (0, _common.getAllQuestionStartNumbersHelper)(adjustedList, allElements);
});
var getIsEmpty = exports.getIsEmpty = (0, _reselect.createSelector)(getElements, getRootId, function (list, rootId) {
  if (list[rootId] && list[rootId].children && list[rootId].children.length > 0) {
    return false;
  }
  return true;
});
var getCurrentPlayerTemplate = exports.getCurrentPlayerTemplate = (0, _reselect.createSelector)(getElements, getRootId, getCurrentElementId, getSettings, function (elements, rootId, currentElementId, settings) {
  var defaultTemplate = {
    name: 'default',
    settings: playerTemplateList.find(function (item) {
      return item.name === 'default';
    }).defaultSettings
  };
  function findTemplate(id) {
    var adjustedSettings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (id === 0 || id === rootId) {
      if (settings && settings.playerTemplate) {
        var template = playerTemplateList.find(function (item) {
          return item.name === settings.playerTemplate;
        });
        return {
          name: settings.playerTemplate,
          settings: _objectSpread(_objectSpread(_objectSpread({}, template && template.defaultSettings), settings.playerTemplateSettings), adjustedSettings)
        };
      }
      return _objectSpread(_objectSpread({}, defaultTemplate), {}, {
        settings: _objectSpread(_objectSpread({}, defaultTemplate.settings), adjustedSettings)
      });
    }
    var element = elements[id];
    if (!element) {
      return defaultTemplate;
    }
    if (element.settings && element.settings.blockPlayerTemplate) {
      var _template = playerTemplateList.find(function (item) {
        return item.name === element.settings.blockPlayerTemplate;
      });
      return {
        name: element.settings.blockPlayerTemplate,
        settings: _objectSpread(_objectSpread(_objectSpread({}, _template && _template.defaultSettings), element.settings.blockPlayerTemplateSettings), adjustedSettings)
      };
    }
    if (id !== currentElementId && element.settings && element.settings.isAdjustedPlayerSettings) {
      adjustedSettings = _objectSpread(_objectSpread({}, element.settings.adjustedPlayerSettings), adjustedSettings);
    }
    var parent = (0, _find2["default"])(elements, function (item) {
      return item.children && item.children.includes(id);
    });
    if (!parent) {
      return defaultTemplate;
    }
    return findTemplate(parent.id, adjustedSettings);
  }
  return findTemplate(currentElementId);
});
var getFakeDynamicUserListsValues = exports.getFakeDynamicUserListsValues = (0, _reselect.createSelector)(getDynamicUserLists, function (lists) {
  var result = {};
  var count = 1;
  lists.forEach(function (list) {
    result[list.handle] = [1, 1, 1].map(function (value, index) {
      return {
        pawnId: 1000000 + count++,
        pawnHash: "".concat(9000000 + count - 1),
        name: "Demo user ".concat(index + 1)
      };
    });
  });
  return result;
});
var getAllElementsAsObject = exports.getAllElementsAsObject = (0, _reselect.createSelector)(getAllElements, function (elements) {
  return elements.reduce(function (obj, element) {
    obj[element.code] = element;
    return obj;
  }, {});
});
var getElementVoices = exports.getElementVoices = (0, _reselect.createSelector)(getRootId, getSettings, getLanguageVoices, getElements, function (rootId, settings, voices, elements) {
  var _settings$playerTempl;
  var result = {};
  function processElement(elementId, voice) {
    var _element$settings, _element$settings$adj;
    var element = elements[elementId];
    if (!element) {
      return;
    }
    voice = (element === null || element === void 0 ? void 0 : (_element$settings = element.settings) === null || _element$settings === void 0 ? void 0 : (_element$settings$adj = _element$settings.adjustedPlayerSettings) === null || _element$settings$adj === void 0 ? void 0 : _element$settings$adj.ttsVoice) || voice;
    result[elementId] = voice;
    if (element.children && element.children.length > 0) {
      var _iterator = _createForOfIteratorHelper(element.children),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var child = _step.value;
          processElement(child, voice);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }
  var initialVoice = (settings === null || settings === void 0 ? void 0 : (_settings$playerTempl = settings.playerTemplateSettings) === null || _settings$playerTempl === void 0 ? void 0 : _settings$playerTempl.ttsVoice) || voices[0].value;
  processElement(rootId, initialVoice);
  return result;
});
var getTextToSpeechStats = exports.getTextToSpeechStats = (0, _reselect.createSelector)(getAllElementsAsObject, getElements, getElementVoices, function (allElements, elements, elementVoices) {
  var result = {
    "new": [],
    updated: [],
    unchanged: 0,
    empty: 0,
    variable: 0,
    custom: 0
  };
  for (var _i = 0, _Object$values = Object.values(elements); _i < _Object$values.length; _i++) {
    var element = _Object$values[_i];
    var elementType = allElements[element.type];
    if (!(elementType !== null && elementType !== void 0 && elementType.ttsFields)) {
      continue;
    }
    var ttsFields = typeof elementType.ttsFields === 'function' ? elementType.ttsFields({
      settings: element.settings
    }) : elementType.ttsFields;
    var _iterator2 = _createForOfIteratorHelper(ttsFields),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _fieldValue$meta, _fieldValue$meta2, _fieldValue$meta3, _fieldValue$meta3$tts, _fieldValue$meta4, _fieldValue$meta4$tts;
        var field = _step2.value;
        var path = typeof field === 'string' ? field : field.path;
        var voice = typeof field === 'string' ? elementVoices[element.id] : field.voice;
        var fieldValue = (0, _get2["default"])(element.settings, path);

        // ignore empty text
        if (!fieldValue) {
          result.empty++;
          continue;
        }
        var text = fieldValue.content || fieldValue;

        // extra check
        if (typeof text !== 'string') {
          result.empty++;
          continue;
        }

        // ignore text with variables
        if (fieldValue !== null && fieldValue !== void 0 && (_fieldValue$meta = fieldValue.meta) !== null && _fieldValue$meta !== void 0 && _fieldValue$meta.variables) {
          result.variable++;
          continue;
        }
        var onlyText = (0, _stripTags["default"])(text, {
          keepImageAltText: false,
          keepTextStyle: false
        });
        if (!onlyText) {
          result.empty++;
          continue;
        }
        var hasAudio = Boolean((_fieldValue$meta2 = fieldValue.meta) === null || _fieldValue$meta2 === void 0 ? void 0 : _fieldValue$meta2.audio);
        var ttsText = (_fieldValue$meta3 = fieldValue.meta) === null || _fieldValue$meta3 === void 0 ? void 0 : (_fieldValue$meta3$tts = _fieldValue$meta3.tts) === null || _fieldValue$meta3$tts === void 0 ? void 0 : _fieldValue$meta3$tts.text;
        var ttsVoice = (_fieldValue$meta4 = fieldValue.meta) === null || _fieldValue$meta4 === void 0 ? void 0 : (_fieldValue$meta4$tts = _fieldValue$meta4.tts) === null || _fieldValue$meta4$tts === void 0 ? void 0 : _fieldValue$meta4$tts.voice;
        if (hasAudio && !ttsText) {
          result.custom++;
          continue;
        }
        if (!ttsText) {
          result["new"].push({
            elementId: element.id,
            path: path,
            text: onlyText,
            voice: voice
          });
          continue;
        }
        if (onlyText.toLowerCase() === ttsText.toLowerCase() && voice === ttsVoice) {
          result.unchanged++;
          continue;
        }
        result.updated.push({
          elementId: element.id,
          path: path,
          text: onlyText,
          voice: voice
        });
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return result;
});
var getCurrentElementVoice = exports.getCurrentElementVoice = (0, _reselect.createSelector)(getCurrentElementId, getElementVoices, function (elementId, elementVoices) {
  return elementVoices[elementId];
});